export const THANK_YOU_COPY = {
  title: 'Thank you for participating',
  subTitle: 'This event has now concluded.',
  learnMoreTitle:
    'Do you want to continue making a difference to your local community? Join Polco for free today.',
  learnMore: 'Learn more',
  goToFeed: 'Explore Polco in your area',
};
